import React, { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { QUESTIONS } from "./coolant-condition-helper";
import { isSelected } from "./air-system-helper";
import CustomCheckBox from "../../../../../core/custom-checkbox";

const CoolantCondition = ({ checklistDetails, setChecklistDetails }) => {
  const [details, setDetails] = useState(
    checklistDetails?.checkList?.coolantSystem || {}
  );

  const onChange = (question, option) => {
    const { apiKey } = question;
    const { apiOptionKey } = option;

    if (question.type === "RADIO") {
      details[apiKey] = option.label;
    } else {
      details[apiOptionKey] = !details[apiOptionKey];
    }

    setDetails({ ...details });
  };

  const onTextChange = (option, text) => {
    const { apiOptionKey } = option;
    details[apiOptionKey] = text;
    setDetails({ ...details });
  };

  useEffect(() => {
    setChecklistDetails((prevVal) => ({
      ...prevVal,
      checkList: {
        ...checklistDetails?.checkList,
        coolantSystem: details,
      },
    }));
  }, [details]);

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Coolant Condition
      </Typography>

      {QUESTIONS?.map((question, index) => (
        <Box key={question.label} sx={{ mb: 3, px: 2 }}>
          <Typography variant="subtitle1">
            {index + 1}. {question.label}
          </Typography>

          <Box display="flex" flexWrap="wrap" gap={2} sx={{ mt: 1 }}>
            {question.type === "INPUT" && (
              <TextField
                variant="outlined"
                fullWidth
                type={question.keyboardType || "text"}
                placeholder={question.label}
                value={details[question.apiKey] || ""}
                onChange={(e) =>
                  setDetails({
                    ...details,
                    [question.apiKey]: e.target.value,
                  })
                }
              />
            )}

            {question.options?.map((option) => {
              if (option.type === "INPUT") {
                return (
                  <TextField
                    key={option.label}
                    label={option.label}
                    variant="outlined"
                    type={option.keyboardType || "text"}
                    value={details[option.apiOptionKey] || ""}
                    onChange={(e) => onTextChange(option, e.target.value)}
                  />
                );
              } else if (option.type === "FILE") {
                return null; // File input not handled in original
              } else {
                return (
                  <CustomCheckBox
                    key={option.label}
                    label={option.label}
                    type={question.type}
                    checked={isSelected(details, question, option)}
                    onChange={() => onChange(question, option)}
                  />
                );
              }
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CoolantCondition;
